import { Link as ChakraLink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

function TcapLink({ children, colorScheme = 'messenger', to, ...props }) {
    return (
        <ChakraLink
            as={Link}
            to={to}
            colorScheme={colorScheme}
            color={`${colorScheme}.500`}
            fontSize="md"
            fontWeight={500}
            _hover={{ color: `${colorScheme}.600` }}
            {...props}>
            {children}
        </ChakraLink>
    );
}

export { TcapLink };
